module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "klickbox-step-content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.quizInternalStyle)
    }
  }), _vm._v(" "), _c('top-message', {
    attrs: {
      "step": _vm.stepActive
    }
  }), _vm._v(" "), _c('config'), _vm._v(" "), _c('step-title', {
    attrs: {
      "step": _vm.stepActive
    }
  }), _vm._v(" "), _c('step-description', {
    attrs: {
      "step": _vm.stepActive
    }
  }), _vm._v(" "), (_vm.stepActive.kind === 'multiple-choice' || _vm.stepActive.kind === 'yes-no') ? _c('multiple-choice', {
    attrs: {
      "step": _vm.stepActive
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stepActive.kind === 'text') ? _c('text-step', {
    attrs: {
      "step": _vm.stepActive
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stepActive.kind === 'email') ? _c('email', {
    attrs: {
      "step": _vm.stepActive
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stepActive.kind === 'redirect') ? _c('redirect', {
    attrs: {
      "step": _vm.stepActive
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stepActive.kind === 'welcome') ? _c('welcome', {
    attrs: {
      "step": _vm.stepActive
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.stepActive.kind === 'multiple-choice' && _vm.stepActive.multiple_answers) || _vm.stepActive.kind === 'text') ? _c('step-next-button', {
    attrs: {
      "step": _vm.stepActive
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('a', {
    staticClass: "flow_button",
    on: {
      "click": function($event) {
        return _vm.canvasChangeView('fluxogram');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sitemap"
  }), _vm._v(_vm._s(_vm.$t('edit.canvas.see_flow')))])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-2bb0ed5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/step/Main.vue
 ** module id = 786
 ** module chunks = 1
 **/